/**
 * Popup Recordatorio de Retiro en Tienda
 * Muestra un popup antes de ir al checkout
 */

(function() {
  'use strict';

  let checkoutProceed = false;

  function showPickupPopup() {
    const popup = document.getElementById('pickup-reminder-popup');
    if (!popup) return;

    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function hidePickupPopup() {
    const popup = document.getElementById('pickup-reminder-popup');
    if (!popup) return;

    popup.style.display = 'none';
    document.body.style.overflow = '';
  }

  function proceedToCheckout() {
    checkoutProceed = true;
    hidePickupPopup();
    
    // Hacer clic en el botón de checkout nuevamente
    const checkoutBtn = document.getElementById('checkout-submit');
    if (checkoutBtn) {
      checkoutBtn.click();
    }
  }

  function interceptCheckoutButton() {
    const checkoutBtn = document.getElementById('checkout-submit');
    if (!checkoutBtn) return;

    const popup = document.getElementById('pickup-reminder-popup');
    if (!popup) return; // Si no hay popup, no interceptar

    checkoutBtn.addEventListener('click', function(e) {
      // Si ya procedió, dejar que continue normalmente
      if (checkoutProceed) {
        checkoutProceed = false; // Reset para próxima vez
        return;
      }

      // Interceptar y mostrar popup
      e.preventDefault();
      e.stopPropagation();
      showPickupPopup();
    }, true); // useCapture = true para interceptar antes
  }

  function setupPopupListeners() {
    const popup = document.getElementById('pickup-reminder-popup');
    if (!popup) return;

    // Botón cerrar (X)
    const closeBtn = popup.querySelector('.pickup-popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', hidePickupPopup);
    }

    // Botón principal
    const actionBtn = popup.querySelector('.pickup-popup-button');
    if (actionBtn) {
      actionBtn.addEventListener('click', proceedToCheckout);
    }

    // Cerrar al hacer clic fuera del popup
    popup.addEventListener('click', function(e) {
      if (e.target === popup) {
        hidePickupPopup();
      }
    });

    // Cerrar con ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.style.display === 'flex') {
        hidePickupPopup();
      }
    });
  }

  function init() {
    setupPopupListeners();
    interceptCheckoutButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init para carritos dinámicos
  document.addEventListener('cart:open', init);
  document.addEventListener('drawer:open', init);

})();
